module.exports = __webpack_public_path__ + "static/shop-2937876e69fb5c8a99149025836f7a92.png";